export const EMETH_CORE_CONTRACT_ADDRESS =
  process.env.REACT_APP_EMETH_CORE_CONTRACT_ADDRESS || "";

export const EMETH_TOKEN_CONTRACT_ADDRESS =
  process.env.REACT_APP_EMETH_TOKEN_CONTRACT_ADDRESS || "";

export const EMETH_PROXY_CONTRACT_ADDRESS =
  process.env.REACT_APP_EMETH_PROXY_CONTRACT_ADDRESS || "";

export const POLYGON_CHAINID = process.env.REACT_APP_POLYGON_CHAINID || "";
